import { useEffect } from "react";
import DrawerWithTitleAndFooter from "../../../../components/drawer/DrawerWithTitleAndFooter";
import SelectDropdown from "../../../../components/dropdown/selectdropdown/SelectDropdown";
import { VEC_ICON_NAME } from "../../../../components/icons/constants";
import RadioInput from "../../../../components/input/radioinput/RadioInput";
import RadioInputWCard from "../../../../components/input/radioinput/radioinputwcard/RadioInputWCard";
import styles from "./ExportRecipientsDrawer.styles"
import { useDispatch, useSelector } from "react-redux";
import { getFormsList } from "./ExportRecipientsDrawerSaga";
import { componentKey, setSelectedExportType, setSelectedForm } from "./ExportRecipientsDrawerSlice";
import Label from "../../../../components/label/Label";
import { LABEL_TYPE } from "../../../../components/label/constants";
import useGarbageCollector from "../../../../../libs/garbagecollector/garbageCollectorHooks";
import Loadable from "../../../../components/loadable/Loadable";
import { RECIPIENT_LISTING_LOADING_STATES } from "../constants";
import { EXPORT_RECIPIENT_DRAWER_LOADING_STATES } from "./constants";
import { RECIPIENT_LISTING_MESSAGE_MAP } from "../constants";

export default function ExportRecipientsDrawer({
    isOpen,
    title = "Export Recipients",
    onCloseCb,
    backButtonProp = {
        backCb: () => { },
        text: "Close",
    },
    submitButtonProp = {
        submitCb: () => { },
        text: "Export",
    },
}) {

    useGarbageCollector(componentKey);
    const dispatch = useDispatch();

    const { loadingState, formsList, selectedForm, selectedExportType } = useSelector(state => state[componentKey])

    useEffect(() => {
        dispatch(getFormsList())
    }, []);

    const { EXPORT_RECIPIENT_FORMS_LOADING, EXPORT_ALL_RECIPIENTS_LOADING, EXPORT_SELECTED_RECIPIENTS_LOADING } = EXPORT_RECIPIENT_DRAWER_LOADING_STATES;

    return (
        <>
            <DrawerWithTitleAndFooter
                isOpen={isOpen}
                onCloseCb={onCloseCb}
                title={title}
                backButtonProp={backButtonProp}
                submitButtonProp={submitButtonProp}
            >

                <Loadable
                    currentState={loadingState.state}
                    loadingStates={[EXPORT_RECIPIENT_FORMS_LOADING, EXPORT_ALL_RECIPIENTS_LOADING, EXPORT_SELECTED_RECIPIENTS_LOADING]}
                    messageMap={RECIPIENT_LISTING_MESSAGE_MAP}
                    isNewLoadable={true}
                >
                    <div style={styles.drawerBody}>
                        <SelectDropdown
                            label="Select a form"
                            placeHolder="Please select a form"
                            options={formsList}
                            value={selectedForm}
                            onSelectCb={(name, selectedOption) => dispatch(setSelectedForm(selectedOption))}
                        />


                        <div>
                            <Label type={LABEL_TYPE.FORM}>Which recipients you want to export?</Label>

                            <div style={styles.recipientOptionContaienr}>
                                <RadioInputWCard
                                    name="recipients"
                                    label={{ prefixLabel: "All" }}
                                    value={"ALL"}
                                    iconName={VEC_ICON_NAME.EXCEL_SHEET_LOGO}
                                    checked={selectedExportType == "ALL"}
                                    onChangeCb={() => dispatch(setSelectedExportType("ALL"))}
                                />

                                <RadioInputWCard
                                    name="recipients"
                                    label={{ prefixLabel: "Selected" }}
                                    value={"SELECTED"}
                                    iconName={VEC_ICON_NAME.EXCEL_SHEET_LOGO}
                                    checked={selectedExportType == "SELECTED"}
                                    onChangeCb={() => dispatch(setSelectedExportType("SELECTED"))}
                                />
                            </div>
                        </div>
                    </div>
                </Loadable>


            </DrawerWithTitleAndFooter >
        </>
    )
}